import DefaultApiService from "./default";

const MGMT = "SLN/Management/EquipmentMasterCatalog";
const CATALOG = "api/EquipmentCatalog";

const wrap = (res, fallback) => ({
  ok: res?.isSuccess !== false && res?.IsSuccess !== false,
  message: res?.message || res?.Message || "",
  data: res?.data ?? res?.Data ?? fallback,
});

const EquipmentMasterCatalogApi = {
  // -------- Categories --------
  getCategories: async (includeInactive = false) =>
    wrap(
      await DefaultApiService.getCustomeApi(
        `${MGMT}/GetCategories?includeInactive=${includeInactive}`
      ),
      []
    ),
  createCategory: async (payload) =>
    wrap(await DefaultApiService.postApi(`${MGMT}/CreateCategory`, payload)),
  updateCategory: async (payload) =>
    wrap(await DefaultApiService.postApi(`${MGMT}/UpdateCategory`, payload)),

  // -------- Brands --------
  getBrands: async (includeInactive = false) =>
    wrap(
      await DefaultApiService.getCustomeApi(
        `${MGMT}/GetBrands?includeInactive=${includeInactive}`
      ),
      []
    ),
  createBrand: async (payload) =>
    wrap(await DefaultApiService.postApi(`${MGMT}/CreateBrand`, payload)),
  updateBrand: async (payload) =>
    wrap(await DefaultApiService.postApi(`${MGMT}/UpdateBrand`, payload)),

  // -------- Manufacturers --------
  getManufacturers: async (includeInactive = false) =>
    wrap(
      await DefaultApiService.getCustomeApi(
        `${MGMT}/GetManufacturers?includeInactive=${includeInactive}`
      ),
      []
    ),
  createManufacturer: async (payload) =>
    wrap(await DefaultApiService.postApi(`${MGMT}/CreateManufacturer`, payload)),
  updateManufacturer: async (payload) =>
    wrap(await DefaultApiService.postApi(`${MGMT}/UpdateManufacturer`, payload)),

  // -------- Items --------
  searchItems: async (query) =>
    wrap(await DefaultApiService.postApi(`${MGMT}/SearchItems`, query), {
      items: [],
      totalCount: 0,
    }),
  getItem: async (id) =>
    wrap(await DefaultApiService.getCustomeApi(`${MGMT}/GetItem?id=${id}`)),
  createItem: async (payload) =>
    wrap(await DefaultApiService.postApi(`${MGMT}/CreateItem`, payload)),
  updateItem: async (payload) =>
    wrap(await DefaultApiService.postApi(`${MGMT}/UpdateItem`, payload)),
  submitItem: async (equipmentItemId) =>
    wrap(
      await DefaultApiService.postApi(`${MGMT}/SubmitItem`, { equipmentItemId })
    ),
  approveItem: async (equipmentItemId) =>
    wrap(
      await DefaultApiService.postApi(`${MGMT}/ApproveItem`, { equipmentItemId })
    ),
  rejectItem: async (equipmentItemId, note) =>
    wrap(
      await DefaultApiService.postApi(`${MGMT}/RejectItem`, {
        equipmentItemId,
        note,
      })
    ),
  deprecateItem: async (equipmentItemId, note) =>
    wrap(
      await DefaultApiService.postApi(`${MGMT}/DeprecateItem`, {
        equipmentItemId,
        note,
      })
    ),

  // -------- Specs --------
  getSpecDefinitions: async (categoryId, includeInactive = false) =>
    wrap(
      await DefaultApiService.getCustomeApi(
        `${MGMT}/GetSpecDefinitions?categoryId=${categoryId}&includeInactive=${includeInactive}`
      ),
      []
    ),
  saveSpecDefinition: async (payload) =>
    wrap(await DefaultApiService.postApi(`${MGMT}/SaveSpecDefinition`, payload)),
  saveSpecValues: async (payload) =>
    wrap(await DefaultApiService.postApi(`${MGMT}/SaveSpecValues`, payload)),

  // -------- Documents / aliases --------
  saveDocument: async (payload) =>
    wrap(await DefaultApiService.postApi(`${MGMT}/SaveDocument`, payload)),
  addAlias: async (payload) =>
    wrap(await DefaultApiService.postApi(`${MGMT}/AddAlias`, payload)),

  // -------- Item requests --------
  getItemRequests: async (status = null) =>
    wrap(
      await DefaultApiService.getCustomeApi(
        `${MGMT}/GetItemRequests${status != null ? `?status=${status}` : ""}`
      ),
      []
    ),
  reviewItemRequest: async (payload) =>
    wrap(await DefaultApiService.postApi(`${MGMT}/ReviewItemRequest`, payload)),

  importSeedExcel: async (file, confirm = false) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("confirm", confirm ? "true" : "false");
    const response = await DefaultApiService.postApi(
      `${MGMT}/ImportSeedExcel`,
      formData
    );
    return wrap(response);
  },

  // -------- Read-only catalog (shared) --------
  search: async (query) =>
    wrap(await DefaultApiService.postApi(`${CATALOG}/Search`, query), {
      items: [],
      totalCount: 0,
    }),
  getByCode: async (code) =>
    wrap(
      await DefaultApiService.getCustomeApi(`${CATALOG}/GetByCode?code=${code}`)
    ),
  getPickerData: async () =>
    wrap(await DefaultApiService.getCustomeApi(`${CATALOG}/GetPickerData`), {
      categories: [],
      brands: [],
    }),
};

export default EquipmentMasterCatalogApi;
